// 支付单（销售合同下的业务单据页面配置）
// 【P9】先选支付信息（payment_product 合同类型）→ 关联区按类型显隐：
//   1 会议室   → 关联会议室订单（本销售合同内，多选+全选，【P13】提交 JSON [[id],...] 对齐老系统，value=id）+ 财务合同（租赁类；首次回款审批通过后自动创建）
//   2/3/5 餐饮/茶歇/其他 → 增值订单 + 财务合同（增值类，仅选已有）
//   4 客户充值 → 仅财务合同（充值类，仅选已有；不选则审批通过后自动创建）
// 提交时指定审批人（财务部门人员，默认陈凯蕾 466）；创建人=当前登录销售。
import {
  getContractPaymentListData,
  saveContractPaymentData,
  saveContractPaymentEditData,
  saveContractPaymentDeleteData
} from "../../api/api.js";

export default {
  key: "payment",
  title: "支付单",
  short: "支付单",
  icon: "card",
  listFn: getContractPaymentListData,
  saveFn: saveContractPaymentData,
  editFn: saveContractPaymentEditData,
  deleteFn: saveContractPaymentDeleteData,
  // 【P24-4】卡片标题：支付单 name（客户X通过Y支付Z元）· 金额
  // 后端 orderPaymentList 返回 name / title_text；name 为空时回退凭证号
  titleFields: ["name", "amount"],
  // 【P24-5/7】支付单筛选：支付时间区间 + 支付类型 + 支付方式 + 支付产品 + 审批状态 + 关键字
  // 【P95-B4 四.1.001~006】
  //   001 支付时间 → BillList 的 daterange 类型已改为 vant 滚轮选择（不再用原生 <input type=date>）
  //   002 支付方式/支付类型/状态 → chips 首项「全部」，默认全部
  //   003 新增金额区间（amount_begin / amount_end，后端 BillListService::applyFilters 支持）
  //   004 共多少条 / 多少金额 → BillList 合计条（billSum 接口）
  //   006 新增 客户 / 商机 / 销售合同 / 财务合同 四个**可搜索选择器**（kind 对应
  //       client/billFilterOptions 的数据源；仅销售端 client 前缀渲染）
  filters: [
    { prop: "payment_date", label: "支付时间", type: "daterange", beginKey: "payment_date_begin", endKey: "payment_date_end" },
    { prop: "amount", label: "金额区间", type: "amountRange" },
    { prop: "payment_method", label: "支付方式", type: "select", optionsFn: "payment_method" },
    { prop: "payment_type", label: "支付类型", type: "select", optionsFn: "payment_type" },
    { prop: "payment_product", label: "合同类型", type: "select", optionsFn: "payment_product" },
    { prop: "status", label: "状态", type: "select", optionsFn: "status" },
    { prop: "owner_id", label: "受理人", type: "select", optionsFn: "owner" },
    { prop: "customer_sn", label: "客户", type: "remote", kind: "customer", placeholder: "全部客户" },
    { prop: "opportunitie_sn", label: "商机", type: "remote", kind: "opportunity", placeholder: "全部商机" },
    { prop: "parent_sn", label: "销售合同", type: "remote", kind: "sales_contract", placeholder: "全部销售合同" },
    { prop: "contracts_sn", label: "财务合同", type: "remote", kind: "finance_contract", placeholder: "全部财务合同" },
    { prop: "searchText", label: "关键字", type: "search", placeholder: "客户 / 商机 / 单号 / 凭证号" }
  ],
  fields: [
    // ===== 支付信息（第一步：先选合同类型，关联区才出现）=====
    {
      prop: "payment_product", label: "合同类型", type: "select", required: true, group: "支付信息",
      placeholder: "先选择合同类型",
      options: [
        { label: "会议室", value: 1 },
        { label: "餐饮", value: 2 },
        { label: "茶歇", value: 3 },
        { label: "客户充值", value: 4 },
        { label: "其他服务", value: 5 }
      ],
      /* 【P323】原【P215 0003】「非充值合同(type!=2) 不允许选『充值』类型」已按用户要求还原：
         客户充值(4) 在所有销售合同下都可见可选。
         原声明 excludeByContractType:{notRecharge:4} 及 mixin::applyPaymentProductLimit ② 的过滤均已删除，
         后端 _contractTabPaymentSaveImpl 的对应 400 拦截同步移除。
         ★ 仍保留：P215 0002（充值合同 type=2 支付方式只能「余额」）、P205（同一合同内 会议室 ⇄ 客户充值 互斥）。 */
      options_note: "P323 已还原：5 类合同类型全量可选"
    },
    {
      prop: "payment_type", label: "支付类型", type: "select", required: true, group: "支付信息",
      placeholder: "请选择支付类型",
      options: [
        { label: "订金", value: 1 },
        { label: "全款", value: 2 },
        { label: "中期款", value: 3 },
        { label: "尾款", value: 4 }
      ]
    },
    {
      // 支付方式（int 编码）；选中后联动回填 pay_type（文本，写入 payment_method_text）
      prop: "payment_method", label: "支付方式", type: "select", required: true, group: "支付信息",
      placeholder: "请选择支付方式",
      /* 【P324】口径（2026-10-13，用户口径）：
         「余额」(6) **不能用于「客户充值」合同类型**（payment_product = 4）；
         其余 4 类（会议室 1 / 餐饮 2 / 茶歇 3 / 其他服务 5）**都可以用余额**，不限制。
         ★ 原【P215 0002】「充值合同(type=2) 只能余额」已移除 —— 销售合同为充值合同时不再强制余额。
         运行时按 payment_product 过滤，过滤在 contractDetailMixin::applyPaymentProductLimit ①。 */
      options: [
        { label: "收钱吧", value: 1, pay_type: "收钱吧" },
        { label: "网银", value: 2, pay_type: "网银" },
        { label: "快团团", value: 3, pay_type: "快团团" },
        { label: "美团", value: 4, pay_type: "美团" },
        { label: "现金", value: 5, pay_type: "现金" },
        { label: "余额", value: 6, pay_type: "余额" },
        { label: "其他", value: 7, pay_type: "其他" }
      ],
      /* 「余额」不可使用的合同类型（payment_product）。仅 4=客户充值。 */
      excludeBalanceForProduct: 4,
      fill: { pay_type: "pay_type" }
    },
    // 支付方式文本（隐藏提交，由 payment_method 联动回填）
    { prop: "pay_type", label: "支付方式文本", type: "hidden" },
    /* 【P100】非余额支付：明确告知需财务审批（避免用户以为提交即完成） */
    {
      prop: "approval_notice", label: "", type: "notice", tone: "warn", group: "支付信息",
      text: "该支付方式需财务人员审批：提交后进入「待财务审核」，审批通过后才生效。",
      showIf: function (form) {
        const m = Number(form.payment_method);
        return m > 0 && m !== 6;
      }
    },
    /* 【P100】余额支付免财务审核提示
       —— 与后端 ApprovalExecuteService::needManual('payment', ...) 口径一致：
          payment_method == 6（余额）时提交即自动通过，不发财务待办。
          同时提示「无需上传凭证」（老系统余额支付免凭证）与「从本合同可用余额扣减」。 */
    {
      prop: "balance_notice", label: "", type: "notice", group: "支付信息",
      text: "余额支付免财务审核：提交后立即生效，无需财务人员审批；金额从本销售合同的可用余额中扣减，因此无需上传凭证。",
      showIf: function (form) { return Number(form.payment_method) === 6; }
    },
    {
      // 收款公司（PC 枚举 source 1-8，与 CRMPaymentOrders 对齐）
      prop: "company_sn", label: "收款公司", type: "select", required: true, group: "支付信息",
      placeholder: "请选择收款公司",
      options: [
        { label: "上海泰耀会展服务有限公司", value: 1 },
        { label: "上海燚耀企业管理有限责任公司", value: 2 },
        { label: "上海枞耀企业管理有限责任公司", value: 3 },
        { label: "上海恪豪企业管理有限责任公司", value: 4 },
        { label: "上海晏耀企业管理有限责任公司", value: 5 },
        { label: "北京泰耀会展服务有限公司", value: 6 },
        { label: "深圳枞耀企业管理有限责任公司", value: 7 },
        { label: "天津枞耀企业管理有限责任公司", value: 8 }
      ]
    },
    {
      prop: "amount", label: "金额", type: "number", required: true, group: "支付信息",
      placeholder: "请输入金额"
    },
    // 06 受理人：本笔回款的受理人（默认当前登录人，可改；保存后回写 owner_id / owner_text）
    {
      prop: "owner_id", label: "受理人", type: "select", group: "支付信息",
      options: [], placeholder: "默认当前登录人", nameKey: "owner_name"
    },
    /* 【P294】支付时间改必填（用户 10-10 20:05）：
       后端 _contractTabPaymentSaveImpl 同时加了兜底校验（编辑 25585 / 新建 27947）。*/
    { prop: "pay_time", label: "支付时间", type: "date", required: true, group: "支付信息" },

    // ===== 关联信息（00/01/02/03/04：按合同类型联动显隐）=====
    {
      /* 【P354】所属客户改为**锁定不可改**（用户 10-14 需求）。
         支付单客户必须与上级销售合同一致，否则收款单与合同客户口径分裂
         （与 P353 商机同一问题）。现 readonly：红星 + 锁图标，不弹选择器；
         值由 contractDetailMixin.openAdd 从合同继承
         （`form.customer_sn = contract.customer_sn`，见该文件 openAdd）。 */
      prop: "customer_sn", label: "所属客户", type: "select", required: true, group: "关联信息",
      options: [], placeholder: "自动继承销售合同客户", nameKey: "customer_name",
      readonly: true
    },
    {
      /* 【P348】所属商机改为**继承上级销售合同、只读不可选**（用户 10-14 需求）。
         值来源：contractDetailMixin.openAdd 已自动带入 contract.opportunitie_sn（见该文件 555 行）。
         readonly + required：显示红星并渲染锁图标，但不提供选择器，
         从源头消除「支付单商机 ≠ 销售合同商机」的数据口径分裂。
         placeholder 改为「选择销售合同后自动带出」。 */
      prop: "opportunitie_sn", label: "所属商机", type: "select", group: "关联信息",
      options: [], placeholder: "自动继承销售合同商机", nameKey: "opportunitie_name",
      readonly: true, required: true
    },
    {
      // 【P12】contracts_sn 语义 = 财务合同 sn（表单不再暴露该字段）：
      // 存草稿时由后端按「关联财务合同」预选值回写；审批通过后由 admin 侧回写实际财务合同 sn
      prop: "contracts_sn", label: "预选财务合同", type: "hidden"
    },
    {
      // 02-001 会议室类：本销售合同内会议室订单，多选 + 全选（【P13】value=id，提交 JSON [[id],...] 对齐老系统）
      prop: "order_meeting_room", label: "关联会议室订单", type: "multiselect", required: true, group: "关联信息",
      options: [], placeholder: "选择本合同内的会议室订单",
      showIf: function (form) { return Number(form.payment_product) === 1; }
    },
    {
      // 03-001 餐饮/茶歇/其他：可选增值订单
      prop: "value_added_servicses_sn", label: "关联增值订单", type: "select", group: "关联信息",
      options: [], placeholder: "选填 · 本合同增值服务订单",
      showIf: function (form) { return [2, 3, 5].indexOf(Number(form.payment_product)) >= 0; }
    },
    {
      // 00/02-002/03-002/04-002 关联财务合同：选项按类型过滤；不选=首次回款（审批通过后自动创建）
      /* 【P307】★ prop 修正：原为 `financial_contracts_sn`（**表单虚拟字段，库里没有这一列**），
         详情页按 prop 取值 ⇒ 恒为「—」。真实列是 t_pro_orders_payment.contracts_sn，
         而展示名由后端 contracts_name 富化。 */
      prop: "contracts_sn", label: "关联财务合同", type: "select", group: "关联信息",
      nameKey: "contracts_name",
      options: [], placeholder: "不选=首次回款，审批通过后自动创建",
      showIf: function (form) { return Number(form.payment_product) >= 1 && Number(form.payment_product) <= 5; }
    },

    // ===== 凭证 =====
    { prop: "number", label: "凭证号", type: "text", group: "凭证", placeholder: "请输入凭证号" },
    {
      /* 【P307】label 统一为「图片」（原「图片上传」与 P307 注入的「图片」重复出现两行） */
      prop: "attachment_image", label: "图片", type: "upload", group: "凭证",
      maxCount: 1, accept: "image/*"
    },
    { prop: "remark", label: "备注", type: "textarea", group: "凭证", placeholder: "选填" },

    // ===== 审批（P9：提交指定财务审批人；创建人=当前登录销售）=====
    {
      prop: "approval_user_id", label: "审批人", type: "select", required: true, group: "审批",
      options: [], placeholder: "财务部门人员 · 默认陈凯蕾"
    }

    // ===== 状态 =====
    // 【P10-1】表单不再选状态：提交成功即「待支付」(status=0，后端默认)，
    //          财务审批通过后由 admin 确认动作置为已支付(status=1)；驳回可编辑重提。
  ]
};



// WEBPACK FOOTER //
// ./src/pages/contract/Payments.js